import { type CountryCode, getCountryCallingCode, isSupportedCountry } from 'libphonenumber-js';
import { useQuery } from '@tanstack/react-query';

import { DICTIONARY } from '../constants';
import { fetchRequest, usePrepareRequest } from '../helpers';
import { type MemberCountryRaw } from '../member/member.types';

export function useGetDDFSCountriesQuery(isEnabled = false) {
  const { headers, endpoint } = usePrepareRequest({ serviceApi: DICTIONARY });

  const queryFn = async () => {
    const response = await fetchRequest<MemberCountryRaw[]>({
      headers,
      url: `${endpoint}/countries`,
    });
    const result = response
      .filter(country => isSupportedCountry(country.countryIso2))
      .map(country => {
        const codeISO2 = country.countryIso2 as CountryCode;
        return {
          codeISO2,
          codeISO3: country.countryIso3,
          name: country.countryName,
          phoneAreaCode: `+${getCountryCallingCode(codeISO2)}`,
        };
      })
      .toSorted((a, b) => a.name.localeCompare(b.name));

    return result;
  };

  return useQuery({
    queryKey: ['ddfsCountries'],
    enabled: isEnabled,
    queryFn: queryFn,
    staleTime: 'static',
  });
}
